import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';
import { RutterConnection } from '~hooks/useRutter/models';
import RutterDisconnectDialog from '~pages/Settings/Integrations/RutterDisconnectDialog';
import { ROUTES as routes } from '~router/routePaths';
import { useStores } from '~store';

const I18N_PREFIX =
  'administration.integration.rutter.quick_books_online.advanced_configuration.disconnect';

interface QuickBooksDisconnectSectionProps {
  connection: RutterConnection;
}

const QuickBooksDisconnectSection = observer(
  ({ connection }: QuickBooksDisconnectSectionProps) => {
    const navigate = useNavigate();
    const { rutterIntegrationStore } = useStores();
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const isDeleting = rutterIntegrationStore.isDeletingConnection.get(connection.id);

    return (
      <Box sx={{ mb: 3, mt: 3 }}>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="h6" sx={{ fontWeight: 'normal' }}>
          {t(`${I18N_PREFIX}.title`)}
        </Typography>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            gap: 2,
            justifyContent: 'space-between',
          }}
        >
          <Typography sx={{ color: 'text.secondary', fontSize: 14 }}>
            {t(`${I18N_PREFIX}.description`)}
          </Typography>
          <SmallButton
            color="error"
            disabled={isDeleting}
            onClick={() => setIsDialogOpen(true)}
            variant="outlined"
          >
            {t('actions.disconnect')}
          </SmallButton>
        </Box>
        <RutterDisconnectDialog
          connection={connection}
          isOpen={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
          onDisconnected={() =>
            navigate(`/${routes.settings.base}/${routes.settings.integrations.base}`)
          }
        />
      </Box>
    );
  },
);

export default QuickBooksDisconnectSection;
